export default __webpack_public_path__ + "static/media/skillsLaunchpadAdvisor.0e88f776.png";